/**
 * @file
 * Global VUE Components
 * Used in library: vue
 *
 * Use this file to register components globally
 * This configuration will be set in @/bootstrap/app.ts
 */

import {ComponentOptions} from 'simpli-web-sdk'

/**
 * Global VUE Components
 */
export const components: ComponentOptions = {}
